import React from "react";
import Headers from "../../../components/Headers";
import { Button, Table, message } from "antd";
import {
  fetchWeChatDetail,
  fetchWeChatBind
} from "../../../api/capitalAccount";
import NProgress from "nprogress";

const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/capitalaccount", name: "资金账户管理" },
  { path: "/page/capitalaccount/businessaccount", name: "商户账户" },
  { path: "/page/capitalaccount/businessaccount", name: "查看详情" }
];
class AccountDetail extends React.Component {
  state = {
    list: []
  };
  async componentDidMount() {
    NProgress.start();
    await this.getList();
    NProgress.done();
  }
  getList = () => {
    console.log("获取列表");
    fetchWeChatDetail({ companyId: this.props.match.params.id }).then(res => {
      if (res.success && Array.isArray(res.data)) {
        res.data.forEach((item, index) => {
          item.key = index;
        });
        this.setState({
          list: res.data
        });
      }
    });
  };
  bind = value => {
    console.log(value);
    const { sendId, receiveId } = value;
    const bind = value.status === "UNBIND" ? true : false;
    fetchWeChatBind({ sendId, receiveId, bind }).then(res => {
      if (res.success) {
        if (res.data) {
          console.log(res);
          message.success("操作成功");
          this.getList();
        } else {
          message.error("操作失败");
        }
      }
    });
  };
  render() {
    const { list } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <Button
          onClick={() =>
            this.props.history.push({
              pathname: "/page/capitalaccount/businessaccount",
              state: {
                key: 2
              }
            })
          }
          style={{ margin: "16px 24px", width: 84 }}
        >
          返回
        </Button>
        <div
          style={{
            margin: "0 24px",
            height: "70%",
            backgroundColor: "#FFF",
            padding: "12px 18px"
          }}
        >
          <Table dataSource={list} pagination={false}>
            <Column title="分账方" dataIndex="sendName" key="sendName" />
            <Column
              title="分账接收方"
              dataIndex="receiveName"
              key="receiveName"
            />
            <Column
              title="状态"
              render={record =>
                record.status === "BIND" ? "已绑定" : "未绑定"
              }
            />
            <Column
              title="操作"
              render={(text, record) => {
                return text.status === "BIND" ? (
                  <a onClick={() => this.bind(text)}>解绑</a>
                ) : (
                  <a onClick={() => this.bind(text)}>绑定</a>
                );
              }}
            />
          </Table>
        </div>
      </div>
    );
  }
}

export default AccountDetail;
